var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'uuid/v4'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/uuid/v4.js' implicitly has an 'any' type.
import uuid from "uuid/v4";
import { AcademicCalendarMultiSearch } from "../../AcademicCalendar/AcademicCalendarSearch";
import { ProgramMultiSearch } from "../../Program/ProgramSearch";
import SearchField from "../../../Form/SearchField";
import ProgramService from "../../../../Services/Program.service";
import AcademicCalendarService from "../../../../Services/AcademicCalendar.service";
import ApplicationStatusDomainService from "../../../../Domain/ApplicationStatus/ApplicationStatus.service";
import CheckboxField from "../../../Form/CheckboxField";
export const WAIT_FOR_APPLICATION_GET_CRITERIA = (formState, { exportNodeId }) => {
    var _a, _b, _c, _d;
    const PERSON_LOADER_DELEGATE_ID = uuid();
    const personLoaderDelegate = {
        id: PERSON_LOADER_DELEGATE_ID,
        type: "PersonLoader",
        criteria: {
            personId: {
                isReference: true,
                workflowNodeReferenceId: exportNodeId,
                propertyName: "studentId",
            },
        },
    };
    return {
        delegates: [personLoaderDelegate],
        criteria: {
            // TODO: This is wrong and will not be used
            studentPersonId: {
                isReference: true,
                workflowNodeReferenceId: PERSON_LOADER_DELEGATE_ID,
                propertyName: "affiliationId",
            },
            applicationStatusIds: {
                value: [ApplicationStatusDomainService.CompletedId],
                isReference: false,
            },
            programIds: {
                value: (_b = (_a = formState.programs) === null || _a === void 0 ? void 0 : _a.map((data) => data.id)) !== null && _b !== void 0 ? _b : [],
                isReference: false,
            },
            academicCalendarIds: {
                value: (_d = (_c = formState.academicCalendars) === null || _c === void 0 ? void 0 : _c.map((data) => data.id)) !== null && _d !== void 0 ? _d : [],
                isReference: false,
            },
            considerHistory: {
                value: formState.considerHistory,
                isReference: false,
            },
        },
    };
};
export const WAIT_FOR_APPLICATION_GET_FORM_STATE = (criteria) => __awaiter(void 0, void 0, void 0, function* () {
    const getAcademicCalendars = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!((_a = criteria.academicCalendarIds.value) === null || _a === void 0 ? void 0 : _a.length)) {
            return [];
        }
        const { data } = yield AcademicCalendarService.lookupSearch({
            ids: criteria.academicCalendarIds.value,
        });
        return data;
    });
    const [academicCalendars, programs] = yield Promise.all([
        getAcademicCalendars(),
        ProgramService.findAllById(criteria.programIds.value),
    ]);
    const considerHistory = criteria.considerHistory.value;
    return {
        academicCalendars,
        programs,
        considerHistory,
    };
});
const WaitForApplicationWorkflowNodeDefinitionForm = ({ name, }) => {
    return (_jsxs(_Fragment, { children: [_jsx(SearchField, { label: "Term(s)", name: name + ".academicCalendars", as: (provided) => (_jsx(AcademicCalendarMultiSearch, Object.assign({ lookupModal: { isInModal: false }, noOptionsMessage: ({ inputValue }) => {
                        if ((inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) < 3) {
                            return "Please type at least 3 characters";
                        }
                        return "No Options";
                    }, minNumSearchCharacters: 3 }, provided))) }), _jsx(SearchField, { label: "Program(s)", name: name + ".programs", as: (provided) => (_jsx(ProgramMultiSearch, Object.assign({ lookupModal: { isInModal: false }, noOptionsMessage: ({ inputValue }) => {
                        if ((inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) < 3) {
                            return "Please type at least 3 characters";
                        }
                        return "No Options";
                    }, minNumSearchCharacters: 3 }, provided))) }), _jsx(CheckboxField, { label: "Consider Existing Data", name: name + ".considerHistory", helpText: "Leaving this box unchecked will only consider applications that have been submitted since the last time this automation was created." })] }));
};
export default WaitForApplicationWorkflowNodeDefinitionForm;
